<template>
  <tr class="ce-formulationAttachment">
    <td class="ce-fa-actions">
      <div class="flex items-center">
        <span class="ce-fa-typeIconWrapper">
          <fa-icon
            @click="downloadAttachment"
            v-if="!downloadRunning"
            :icon="icon" />

          <fa-icon
            v-else
            icon="spinner"
            spin />
        </span>
      </div>
    </td>

    <td
      class="ce-fa-label"
      @click="downloadAttachment">
      {{ attachment.title }}
    </td>
  </tr>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { saveAs } from 'file-saver';
import { getIconForMimeType } from 'utils/icons';
import { axiosBlobClient } from 'utils/download';
import BackendApiService from 'services/BackendApiService';

export default {
  props: {
    attachment: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      downloadRunning: false,
    };
  },
  computed: {
    ...mapState(['formulation']),
    ...mapState('generic', ['services']),
    ...mapGetters('user', ['token']),
    icon() {
      return getIconForMimeType(this.attachment.mimeType);
    }
  },
  methods: {
    async downloadAttachment() {
      this.downloadRunning = true;

      try {
        const apiResponse = await BackendApiService.getFormulationAttachmentDownloadUri(this.formulation.id, this.attachment.id, this.token);

        if (apiResponse?.downloadUri) {
          const fileResponse = await axiosBlobClient.get(apiResponse.downloadUri);
          saveAs(new Blob([fileResponse.data]), this.attachment.name);
        }
        this.downloadRunning = false;
      } catch (e) {
        this.downloadRunning = false;
        this.$notification.error(e.response?.data?.message ?? e.message);
      }
    }
  }
};
</script>

<style lang="less">
@import (reference) '~styles/includes/base';

.ce-formulationAttachment {
  cursor: pointer;

  > td {
    padding-bottom: @space-2;
  }

  span {
    text-decoration: underline;
  }

  .ce-fa-actions {
    > div {
      margin: 0 @space-3 0 -@space-1;

      > * {
        margin: 0 @space-1;
      }

      a {
        color: @color-text-base;
      }
    }
  }

  .ce-fa-label {
    transition: color 250ms ease-in-out;
    color: @color-text-base;

    a {
      color: @color-text-base;
    }

    &:hover {
      &, a {
        color: @color-light;
      }
    }
  }

  .ce-fa-typeIconWrapper {
    width: 16px;
  }
}
</style>
